/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_HubspotInputs */



/**
* | output |
* | --- |
* | "Contacts, companies and deals from your CRM." |
*
* @param {Spaces_Gallery_Desc_HubspotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_gallery_desc_hubspot = /** @type {((inputs?: Spaces_Gallery_Desc_HubspotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_HubspotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontakte, Unternehmen und Deals aus deinem CRM.")
	return /** @type {LocalizedString} */ ("Contacts, companies and deals from your CRM.")
});